/* import __COLOCATED_TEMPLATE__ from './client-form-therapyfinder-embed.hbs'; */
import ContactInformationClientForm from './client-form';

export default class ContactInformationClientFormTherapyfinderEmbed extends ContactInformationClientForm {}
